module.exports = __webpack_public_path__ + "img/video_link_test_icon.695ce808.svg";